/** Опубликованные сервисы (пути на сервере)*/
export enum AppServices {
  CRM = 'rental-crm-be',
  MOBILE_BFF = 'mobile-bff',
}
